export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会員コード"])}
    }
  })
}
